interface IProps {
  titre?: string;
  titreClass?: string;
  donnee?: string | number;
  elem?: JSX.Element | null;
  prefixe?: string;
  suffixe?: string;
  titreCol?: string;
  donneeCol?: string;
  color?: string;
}

const RowDetail: React.FC<IProps> = ({
  titre,
  donnee,
  prefixe = "",
  suffixe = "",
  elem,
  titreClass,
  titreCol,
  donneeCol,
  color,
}: IProps) => {
  const N = (a: any) => a === null ? "" : a;

  return (
    <div className="row">
      <div
        className={`col-${titreCol ? titreCol : "4"} ${titreClass ? titreClass : "pae-detail-label"}`}
        style={{ textAlign: 'left' }}
      >
        <b>{titre}</b>
      </div>
      <div
        className={`col-${donneeCol ? donneeCol : "8"}`}
        style={{ textAlign: 'left', color: color }}
      >
        {/* Apply italic based on the 'italic' prop */}
        {elem !== undefined ? (
          elem !== null ? elem : <></>
        ) : (
          <>
            {donnee ? N(prefixe) + donnee + N(suffixe) : "_"}
          </>
        )}
      </div>
    </div>
  );
};

export default RowDetail;
